<template>
   <!-- <div> -->
    <div class="w-[75%]" id="mapid" ref="mapElement">
      <!-- <div>
        TO: {{ to }} FROM: {{ from }}
      </div> -->
      
    </div>
  <!-- </div> -->

</template>

<script>

import * as L from "leaflet";
import { vectorBasemapLayer } from 'esri-leaflet-vector';
// import { FeatureLayer } from "esri-leaflet";
import streetsVue from './streets.vue';
import restaurantsVue from "./restaurants.vue";
import pfennigparadeVue from "./pfennigparade.vue";
import ubahnsVue from "./ubahns.vue";
import destinationsVue from "./destinations.vue";

var geojsonFeature = streetsVue.data().geojsonFeature;
console.log(streetsVue.data().geojsonFeature)


var geojsonRestaurantFeature = restaurantsVue.data().geojsonFeature;
var geojsonPfennigparadeFeature = pfennigparadeVue.data().geojsonFeature;
var geojsonUbahnsFeature = ubahnsVue.data().geojsonFeature;
var geojsonDestinationsFeature = destinationsVue.data().geojsonFeature;



function dateOfEntryColors(dateOfEntry) {
  if(dateOfEntry == "1.0")
    return '#d494f8'
  else if(dateOfEntry == "2.0")
    return '#c500ff'
  else
    return '#750095'
}

// https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.pngfind.com%2Fmpng%2FToiioo_location-clipart-location-pin-office-location-icon-png%2F&psig=AOvVaw3hTPNhJIV3vfuFc-XvsKxB&ust=1674036949570000&source=images&cd=vfe&ved=0CA0QjRxqFwoTCJDUi-WvzvwCFQAAAAAdAAAAABAY
const destinations = {
  'Scheidplatz U-Bahn Station': {
    routeName: "scheidplat", 
    destinationType: "ubahn"
  },
  'Milbertshofen U-Bahn Station': {
    routeName: "milbertsho",  
    destinationType: "ubahn"
  },
  'Olympiazentrum U-Bahn Station': {
    routeName: "olympiazen", 
    destinationType: "ubahn"
  },
  'Hans im Glück': {
    routeName: "hansImGlue", 
    destinationType: "restaurant"
  },
  'BMW Museum': {
    routeName: "bmwMuseum", 
    destinationType: "destination"
  },
  'St. Mauritius Apotheke': {
    routeName: "apotheke", 
    destinationType: "destination"
  },
  'Bei Ling Chinese Restaurant': {
    routeName: "chineseRes", 
    destinationType: "restaurant"
  },
  'Burgerhouse 3 Biergarten': {
    routeName: "burgerhous", 
    destinationType: "restaurant"
  },
  'Commerzbank': {
    routeName: "commerzban", 
    destinationType: "destination"
  },
  'Deutsche Bundesbank': {
    routeName: "deutscheBu", 
    destinationType: "destination"
  },
  'Deutsche Post': {
    routeName: "deutschePo", 
    destinationType: "destination"
  },
  'Luitpoldpark': {
    routeName: "luitpoldpa", 
    destinationType: "destination"
  },
  'Marta Trattoria & Bar': {
    routeName: "martaTratt", 
    destinationType: "restaurant"
  },
  'Olympiapark': {
    routeName: "olympiapar", 
    destinationType: "destination"
  },
  'Petuelpark': {
    routeName: "petuelpark", 
    destinationType: "destination"
  },
  'Petuelring U-Bahn Station': {
    routeName: "petuelring", 
    destinationType: "ubahn"
  },
  'Rabiang Thai Restaurant': {
    routeName: "thaiRestau", 
    destinationType: "restaurant"
  },
  'Stadtsparkasse': {
    routeName: "stadtparka", 
    destinationType: "destination"
  },
  'Rewe': {
    routeName: "rewe", 
    destinationType: "destination"
  },
}

// function styleMap(feature){
//   if(feature.properties && feature.properties[destinations["Olympiazentrum U-Bahn Station"].routeName] == 1) {
//     const entry = feature.properties.dateOfEntr
//     const color = dateOfEntryColors(entry);
//     return { color: color };
//   } else {
//     return { opacity: 0 }
//   }
// }

// function styleMapDB(feature){
//   if(feature.properties && feature.properties.deutscheBu.routeName == 1) {
//     const entry = feature.properties.dateOfEntr
//     const color = dateOfEntryColors(entry);
//     return { color: color };
//   } else {
//     return { opacity: 0 }
//   }
// }



// function pointToDestinationsLayer(feature, latlng) {
//   var smallIcon = L.icon({
//       iconUrl: require('./../assets/destinationsLogo.svg'),
//       iconSize: [20, 30], // size of the icon
//       // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
//       // popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
//   });
//   return L.marker(latlng, {icon: smallIcon});
// }

// function pointToPfennigparadeLayer(feature, latlng) {
//   var smallIcon = L.icon({
//       iconUrl: require('./../assets/pfennigparadeLogo.svg'),
//       iconSize: [30, 30], // size of the icon
//   });
//   return L.marker(latlng, {icon: smallIcon});
// }

// function pointToRestaurantLayer(feature, latlng) {
//   var smallIcon = L.icon({
//       iconUrl: require('./../assets/restaurantsLogo.svg'),
//       iconSize: [30, 30], // size of the icon
//   });
//   return L.marker(latlng, {icon: smallIcon});
// }

// function pointToUbahnsLayer(feature, latlng) {
//   var smallIcon = L.icon({
//       iconUrl: require('./../assets/ubahnsLogo.svg'),
//       iconSize:     [30, 30], // size of the icon
//   });
//   return L.marker(latlng, {icon: smallIcon});
// }

// function getColor(d) {
//     return d === 'Up to one month ago'  ? "#de2d26" :
//           d === 'One to six months ago'  ? "#377eb8" :
//           d === 'More than six months ago' ? "#4daf4a" :
//           "#ff7f00";
// }




export default {
  name: "esriMap",
  components: {
  },
  props: ['from','to'],
  data() {
    return {
      // fromhere: this.from,
      // startingpoint: '',
      mymap: '',
      mymapMap: '',
      zoomLevel: 15,
      pfennigparadeBounds: ''
    }
  },
  watch:{
      from: {
          immediate: true,
          handler(){
              var from = this.from;
              console.log("FIRED ON MOUNT! from: " + this.from + " to: " + this.to);

              function styleStreets(feature){
                if(feature.properties && destinations[from]!==undefined && feature.properties[destinations[from].routeName] == 1) {
                  const entry = feature.properties.dateOfEntr
                  const color = dateOfEntryColors(entry);
                  return { color: color };
                } else {
                  return { opacity: 0 }
                }
              }

              function onEachFeature(feature, layer) {
                if (feature.properties && feature.properties.name == from && destinations[from]!==undefined) {
                  var customOptions =
                  {
                    'background': 'None',
                    'white-space': 'normal'
                  }
                  if(destinations[from].destinationType == "restaurant" || destinations[from].destinationType == "destination") {
                    var websiteLink = ""
                    // console.log(feature.properties.website)
                    if(feature.properties.website != "-") {
                      websiteLink += "<a href=\"https://" + feature.properties.website + "\"target=\"_blank\" rel=\"noopener noreferrer\">" + feature.properties.website + "</a>"
                    } else {
                      websiteLink += "-"
                    }
                    // console.log("website link " + websiteLink)
                    layer.bindPopup("<dl><dt><b>" + 
                      feature.properties.name + 
                      "</b></dt> <dt>Address: " + feature.properties.address + "</dt>" +
                      "</dt> <dt>Toilets: " + feature.properties.toilets + "</dt>" +
                      "</dt> <dt>Website: " + websiteLink + "</dt></dl>", 
                      customOptions);
                    layer.on('mouseover', () => { layer.openPopup(); });
                    layer.on('onclick', () => { layer.closePopup(); });
                  } else if (destinations[from].destinationType == "ubahn") {
                    layer.bindPopup("<b>" + feature.properties.name + "</b>",
                      customOptions);
                    layer.on('mouseover', () => { layer.openPopup(); });
                    layer.on('onclick', () => { layer.closePopup(); });
                  } else {
                    layer.bindPopup("Error: unknown destination",
                      customOptions);
                    layer.on('mouseover', () => { layer.openPopup(); });
                    layer.on('onclick', () => { layer.closePopup(); });
                  }
                  
                }
              }

              function pointToUbahnsLayer(feature, latlng) {
                console.log("ubahns 2")
                if (feature.properties && feature.properties.name == from){
                  var smallIcon = L.icon({
                      iconUrl: require('./../assets/ubahnsLogo.svg'),
                      iconSize:[25, 25], // size of the icon
                  });
                  return L.marker(latlng, {icon: smallIcon});
                }
              }

              function pointToDestinationsLayer(feature, latlng) {
                if (feature.properties && feature.properties.name == from){
                  var smallIcon = L.icon({
                      iconUrl: require('./../assets/destinationsLogo.svg'),
                      iconSize: [20, 30], // size of the icon
                      // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
                      // popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
                  });
                  return L.marker(latlng, {icon: smallIcon});
                }
              }
              function pointToRestaurantLayer(feature, latlng) {
                console.log("restaurants 2")
                console.log(feature.properties.name)
                
                if (feature.properties && feature.properties.name == from){
                  var smallIcon = L.icon({
                      iconUrl: require('./../assets/restaurantsLogo.svg'),
                      iconSize: [30, 30], // size of the icon
                  });
                  return L.marker(latlng, {icon: smallIcon});
                }
              }
              // var  destinations[from] !== undefined
              if (from != 'ff') {
                console.log("helloooo")
                console.log(from)
               

                console.log(from === "")
                console.log(destinations[from] !== undefined)
                var destinationLatLong;
                this.mymap.clearLayers();
                var startLat = 11.576584406886893;
                var startLong = 48.176704528962418;
                if(destinations[this.from]!==undefined) {
                  var stylingStreetLayer = L.geoJSON(geojsonFeature , {style: styleStreets});
                  stylingStreetLayer.addTo(this.mymap);
                  
                  if(destinations[from].destinationType == "destination"){ 
                    var stylingDestinationIconsLayer = L.geoJSON(geojsonDestinationsFeature, {
                      onEachFeature: onEachFeature,
                      pointToLayer: pointToDestinationsLayer
                    });
                    stylingDestinationIconsLayer.addTo(this.mymap);
                    destinationLatLong = geojsonDestinationsFeature.features.filter(({properties}) => properties.name === from);
                  } else if (destinations[from].destinationType == "ubahn"){ 
                    var stylingUbahnIconsLayer = L.geoJSON(geojsonUbahnsFeature, {
                      onEachFeature: onEachFeature,
                      pointToLayer: pointToUbahnsLayer
                    });
                    stylingUbahnIconsLayer.addTo(this.mymap);
                    destinationLatLong = geojsonUbahnsFeature.features.filter(({properties}) => properties.name === from);
                  } else if (destinations[from].destinationType == "restaurant"){ 
                    console.log("restaurants 1")
                    var stylingRestaurantIconsLayer = L.geoJSON(geojsonRestaurantFeature, {
                      onEachFeature: onEachFeature,
                      pointToLayer: pointToRestaurantLayer
                    });
                    stylingRestaurantIconsLayer.addTo(this.mymap);
                    destinationLatLong = geojsonRestaurantFeature.features.filter(({properties}) => properties.name === from);
                  } else {
                    
                    return;
                  }
                  var endLat = destinationLatLong[0].geometry.coordinates[0];
                  var endLong = destinationLatLong[0].geometry.coordinates[1];
                  
                  var middleLat = (endLat+startLat)/2
                  var middleLong = (endLong+startLong)/2
                  this.mymapMap.setView([middleLong, middleLat], 15);
                } else {
                  console.log("in the else statement")
                  this.mymapMap.setView([startLong, startLat], 15);
                  
                }

              } else {
                // this.mymapMap.setView([startLong, startLat], 15);
                console.log("nothing");
                console.log(this.from);
              }

          }
      },
      to: {
          immediate: true,
          handler(){
            console.log("to ", this.to)
          }
      }
  },
  // data() {
  //   return {
  //     mygeojsonFeature: geojsonFeature
  //   }
  // },
  // computed: {
  //   names() {
  //     return geojsonFeature.features.map((item) => {
  //       console.log(item.properties)
  //       return;
  //     })
  //   }
  // },

  methods: {
    updateparent(startpt) {
        this.parentvariable = startpt
    }
  },

  mounted() {
    var mymap = L.map(this.$refs['mapElement'], {zoomAnimation:false,fadeAnimation:true,markerZoomAnimation:true}).setView([48.17748059324898, 11.575627598020361], 15);
    this.mymapMap = mymap;
    const apiKey = "AAPKa309e24f0b1641689ff035269dc0a137pZ1L6qDDCl4h-ElD2vJya87wSdTuXuBjjUq22_ThvEjMHmVM-VDZnC8GMTS93lnW";
    const basemapEnum = "ArcGIS:DarkGray";
    // mymap.on('zoomend', function() {
    //   var currentZoom = mymap.getZoom();
    //   this.zoomLevel = currentZoom;
    //   console.log(this.zoomLevel)
    //   console.log("current zoom " + currentZoom)
    //   if (currentZoom>12) {
    //     console.log("more than 12")
    //   // what should I do here to access all markers in the all_testptLayer and change the size of all markers to double in size?
    //   }
    // });
    vectorBasemapLayer(basemapEnum, {
      apiKey: apiKey
    }).addTo(mymap);

    function onEachPfennigparadeFeature(feature, layer) {
      if(feature.properties && feature.properties.name) {
        var customOptions = {
          'background': 'None'
        }
        layer.bindPopup("<dl><dt><b>" + 
          feature.properties.name + 
          "</b></dt> <dt>Address: " + feature.properties.address + "</dt>" +
          "</dt> <dt>Website: " + "<a href=\"https://" + feature.properties.website + "\"target=\"_blank\" rel=\"noopener noreferrer\">" +
          feature.properties.website + "</a> </dt> </dl>", 
          customOptions);
        layer.on('mouseover', () => { layer.openPopup(); });
        layer.on('onclick', () => { layer.closePopup(); });
      }
    }

    function pointToPfennigparadeLayer(feature, latlng) {
      if (feature.properties){
        var smallIcon = L.icon({
            iconUrl: require('./../assets/pfennigparadeLogo.svg'),
            iconSize: [30, 30], // size of the icon
        });
        return L.marker(latlng, {icon: smallIcon});
      }
    }

    var stylingPfennigparadeLayer = L.geoJSON(geojsonPfennigparadeFeature, {
      onEachFeature : onEachPfennigparadeFeature,
      pointToLayer : pointToPfennigparadeLayer
    })
    stylingPfennigparadeLayer.addTo(mymap);

    L.control.scale({position:'bottomleft', metric: true, imperial: false}).addTo(mymap);

    

    // var legend = L.control({position: 'bottomright'});
    // legend.onAdd = function () {

    //     var div = L.DomUtil.create('div', 'info legend'),
    //         grades = [" Pfennigparade", " U-Bahn", " Restaurant", " Destination"],
    //         labels = [
    //           require('@/assets/pfennigparadeLogo.svg'), 
    //           require('@/assets/ubahnsLogo.svg'),
    //           require('@/assets/restaurantsLogo.svg'), 
    //           require('@/assets/destinationsLogo.svg') 
    //         ];

    //     // loop through our density intervals and generate a label with a colored square for each interval
    //     for (var i = 0; i < grades.length; i++) {
    //         div.innerHTML +=
    //              (" <img src="+ labels[i] +" height='30' width='30'>") + grades[i] +'<br>';
    //     }

    //     return div;
    // };

    // legend.addTo(mymap);

    // var stylingRestaurantsLayer = L.geoJSON(geojsonRestaurantFeature, {
    //   onEachFeature : onEachFeature,
    //   pointToLayer : pointToLayer
    // })
    // stylingRestaurantsLayer.addTo(mymap);

    // var stylingDestinationsLayer = L.geoJSON(geojsonDestinationsFeature, {
    //   onEachFeature : onEachFeature,
    //   pointToLayer : pointToLayer
    // })
    // stylingDestinationsLayer.addTo(mymap);

    // var stylingPfennigparadeLayer = L.geoJSON(geojsonPfennigparadeFeature, {
    //   onEachFeature : onEachFeature,
    //   pointToLayer : pointToPfennigparadeLayer
    // })
    // stylingPfennigparadeLayer.addTo(mymap);

    // var stylingUbahnsLayer = L.geoJSON(geojsonUbahnsFeature, {
    //   onEachFeature : onEachFeature,
    //   pointToLayer : pointToLayer
    // })
    // stylingUbahnsLayer.addTo(mymap);
    

    // var legend = L.control({position: 'bottomleft'});
    // legend.onAdd = function() {
    //   var div = L.DomUtil.create('div', 'info legend');
    //   labels = ['<strong>Streets</strong>'],
    //   categories = ['Up to one month ago','One to six months ago','More than six months ago'];

    //   for (var i = 0; i < categories.length; i++) {

    //           div.innerHTML += 
    //           labels.push(
    //               '<i class="circle" style="background:' + getColor(categories[i]) + '"></i> ' +
    //           (categories[i] ? categories[i] : '+'));

    //       }
    //       div.innerHTML = labels.join('<br>');
    //   return div;
    // };
    // legend.addTo(this.mymap);

    this.mymap = L.featureGroup().addTo(mymap)

  },
  // beforeUpdate() {
  //   var stylingLayer = L.geoJSON(geojsonFeature , {style: styleMap})
  //   console.log("before update");
  //   console.log(this.from);
  //   // function styleMapRemove(feature){
  //   //   const entry = feature.properties.dateOfEntr
  //   //       // const color = dateOfEntryColors(entry);
  //   //       return { opacity: 0 };
  //   // }

  //   if(this.from == "Burger King") {
  //     stylingLayer.addTo(this.mymap);
  //   } else {
  //     this.mymap.removeLayer(stylingLayer)
  //     console.log("not burger king")
  //   }
  // }
}
</script>

<style scoped>
/* #mapid { 
    height: 600px;
} */
</style>